import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["keyboard", "textfield", "titlefield", "footer", "assets", "files", 
                      "submitButton", "videoDuration", "deletedImages"]
    
    connect(){
        this.container = document.getElementById("container") 
        if(!this.container){
            this.dt = new DataTransfer();
            this.newsGrid = document.querySelector(".news-grid-container");
            this.acceptedImageTypes = ['image/jpeg', 'image/png', 'video/mp4', 'video/quicktime'];
            this.deletedImages = [];
            this.images = document.getElementById("images");
            const inputFields = [this.textfieldTarget, this.titlefieldTarget];
            const button = document.getElementById("news_submit");

            inputFields.forEach(function(element){
                element.addEventListener("input", function(){
                    if(inputFields[0].value.length > 0 && inputFields[1].value.length > 0){
                        button.removeAttribute("disabled");
                        button.setAttribute("style", "color: #e52924;")
                    } else {
                        button.setAttribute("disabled", "disabled")
                        button.setAttribute("style", "color: #AFAFAF")
                    }
                });
            })
            if(document.getElementById("edit")){
                button.removeAttribute("disabled");
                button.setAttribute("style", "color: #e52924;")
                
                var imagesGrid = [] 
                var el = document.querySelectorAll('.news-assets-item')
                for (var i = 0; i < el.length; i++) {
                    if(i !== 0){
                        var file = new File([""], "");
                        this.dt.items.add(file)
                        imagesGrid.push(el[i])
                    }
                }
                this.addImageToGrid(imagesGrid)
            }

            if(document.getElementsByTagName('video') && document.getElementsByTagName('video').length > 1){
                const assets = document.getElementsByTagName('video'); 
                for (let i = 1; i < assets.length; i++) {
                    const element = assets[i];
                    element.onloadedmetadata = function(){
                        var sec_num = parseInt(this.duration, 10)
                        var hours   = Math.floor(sec_num / 3600)
                        var minutes = Math.floor(sec_num / 60) % 60
                        var seconds = sec_num % 60
                    
                        var time =  [hours,minutes,seconds]
                            .map(v => v < 10 ? "0" + v : v)
                            .filter((v,i) => v !== "00" || i > 0)
                            .join(":")
                        this.parentElement.children[1].children[0].children[1].innerText = time;
                    }   
                }
            }
        }
    }

    openKeyboard(){
        if(this.titlefieldTarget.value.length === 0){
            this.titlefieldTarget.focus();
        } else {
            this.textfieldTarget.focus();
        }
    }

    chooseImage(){
        this.assetsTarget.setAttribute("accept", "image/png,image/jpeg");
    }

    chooseVideo(){
        this.assetsTarget.setAttribute("accept", "video/mp4,video/x-m4v,video/*,video/quicktime");
    }

    uploadFile(e){
        if (e.target.files.length >= 6 || this.dt.files.length >= 6){
            alert("You have reached your limit! You can upload only 6 images/videos");
        } else{
            const files = e.target.files;
            for (var i = 0; i < files.length; i++) {
                this.dt.items.add(files[i]);  
                this.showPreview(files[i]);
            }
            e.target.files = this.dt.files;
        }
    }

    removeFile(e){
        const newDataTransfer = new DataTransfer();
        const parent = e.target.parentElement; 
        const file = parent.lastChild.files[0];       
        var status = false; 
        for (let i = 0; i < this.dt.files.length; i++) {
            if(this.dt.files[i] === file){
                status = true;        
            }
            else {
                newDataTransfer.items.add(this.dt.files[i]);
            }
        }

        if(status === true){
            this.dt.items.remove(file);            
            parent.remove();
            this.dt = newDataTransfer;   
        }
        this.addImageToGrid(this.dt.files);
    }


    removeExistedFile({params}){
        this.deletedImages.push(params.id);
        this.images.setAttribute("value", this.deletedImages)
        event.target.parentElement.remove();
        this.dt.items.remove(this.dt.items[0]);
        this.addImageToGrid(this.dt.files)

    }

    showPreview(file){
        const assetItem = this.filesTarget.cloneNode(true);
        const src = URL.createObjectURL(file);
        assetItem.lastChild.files = this.getFiles(file);
        assetItem.classList.remove("hidden");
        if(this.acceptedImageTypes.includes(file['type'])){
            if(file['type'] === 'video/mp4' ){
                assetItem.children[2].remove();
                assetItem.children[1].classList.remove("hidden");
                assetItem.children[2].classList.remove("hidden");
                const video = assetItem.children[2];
                video.src = src
                video.onloadedmetadata = function() {
                    var sec_num = parseInt(video.duration, 10)
                    var hours   = Math.floor(sec_num / 3600)
                    var minutes = Math.floor(sec_num / 60) % 60
                    var seconds = sec_num % 60
                
                    var time =  [hours,minutes,seconds]
                        .map(v => v < 10 ? "0" + v : v)
                        .filter((v,i) => v !== "00" || i > 0)
                        .join(":")
                    assetItem.children[1].children[0].children[1].innerText = time;
                }
                assetItem.children[2].setAttribute("src", `${src}#t=0.1`);
            } else {
                assetItem.children[2].setAttribute("src", src);
            }
        }
        this.newsGrid.appendChild(assetItem);
        this.addImageToGrid(this.dt.files);
    }

    addImageToGrid(files){
        if(files.length === 1){
            this.newsGrid.children[1].style = "grid-column: 1; grid-row: 1; height: 250px";
            this.newsGrid.children[1].children[2].style = "height: 250px";
        } else if(files.length === 2) {
            this.newsGrid.children[1].style = "grid-column: 1; grid-row: 1;  height: 118px";
            this.newsGrid.children[1].children[2].style = "height: 118px";
            this.newsGrid.children[2].style = "grid-column: 2; grid-row: 1; height: 118px";
            this.newsGrid.children[2].children[2].style = "height: 118px";
        } else if(files.length === 3) {
            this.newsGrid.children[1].style = "grid-column: 1; grid-row: 1 / span 2; height: 240px";
            this.newsGrid.children[1].children[2].style = "height: 240px";
            this.newsGrid.children[2].style = "grid-column: 2; grid-row: 1; height: 118px";
            this.newsGrid.children[2].children[2].style = "height: 118px";
            this.newsGrid.children[3].style = "grid-column: 2; grid-row: 2; height: 118px";
            this.newsGrid.children[3].children[2].style = "height: 118px";
        } else if(files.length === 4) {
            this.newsGrid.children[1].style = "grid-column: 1; grid-row: 1; height: 170px";
            this.newsGrid.children[1].children[2].style = "height: 170px;";
            this.newsGrid.children[2].style = "grid-column: 2; grid-row: 1; height: 170px";
            this.newsGrid.children[2].children[2].style = "height: 170px";
            this.newsGrid.children[3].style = "grid-column: 1; grid-row: 2; height: 170px";
            this.newsGrid.children[3].children[2].style = "height: 170px";
            this.newsGrid.children[4].style = "grid-column: 2; grid-row: 2; height: 170px";
            this.newsGrid.children[4].children[2].style = "height: 170px";
        } else if(files.length === 5) {
            this.newsGrid.children[1].style = "grid-area: 1 / 1 / 1 / 4; height: 170px;";
            this.newsGrid.children[1].children[2].style = "height: 170px";
            this.newsGrid.children[2].style = "grid-area: 1 / 4 / 1 / 7; height: 170px;";
            this.newsGrid.children[2].children[2].style = "height: 170px";
            this.newsGrid.children[3].style = "grid-column: auto / span 2; grid-row: 2; height: 112px";
            this.newsGrid.children[3].children[2].style = "height: 112px";
            this.newsGrid.children[4].style = "grid-column: auto / span 2; grid-row: 2; height: 112px";
            this.newsGrid.children[4].children[2].style = "height: 112px";
            this.newsGrid.children[5].style = "grid-column: auto / span 2; grid-row: 2; height: 112px";
            this.newsGrid.children[5].children[2].style = "height: 112px";
        } else if(files.length === 6) {
            this.newsGrid.children[1].style = "grid-column: 1; grid-row: 1; height: 112px";
            this.newsGrid.children[1].children[2].style = "height: 112px";
            this.newsGrid.children[2].style = "grid-column: 2; grid-row: 1; height: 112px";
            this.newsGrid.children[2].children[2].style = "height: 112px";
            this.newsGrid.children[3].style = "grid-column: 3; grid-row: 1; height: 112px";
            this.newsGrid.children[3].children[2].style = "height: 112px";
            this.newsGrid.children[4].style = "grid-column: 1; grid-row: 2; height: 112px";
            this.newsGrid.children[4].children[2].style = "height: 112px";
            this.newsGrid.children[5].style = "grid-column: 2; grid-row: 2; height: 112px";
            this.newsGrid.children[5].children[2].style = "height: 112px";
            this.newsGrid.children[6].style = "grid-column: 3; grid-row: 2; height: 112px";
            this.newsGrid.children[6].children[2].style = "height: 112px";
        }
    }

    getFiles(file){
        const dtFiles = new DataTransfer();
        const data = this.dt.files;
        for (let i = 0; i < data.length; i += 1) {
            if(data[i] === file){
                dtFiles.items.add(file);
            }
        }
        return dtFiles.files;
    }

    async createNews(){
        this.submitButtonTarget.setAttribute("disabled", "disabled")
        if (window?.Android && typeof window.Android.onBack == "function") {
            Android.onBack();
            return;
        } else if (window.webkit && window.webkit.messageHandlers) {
            await new Promise(r => setTimeout(r, 200));
            webkit.messageHandlers.performAction.postMessage({
              action: "navigateToBack",
            });
        }
    }

    async deleteNews(){
        if (window?.Android && typeof window.Android.onBack == "function") {
            Android.onBack();
            return;
        } else if (window.webkit && window.webkit.messageHandlers) {
            await new Promise(r => setTimeout(r, 200));
            webkit.messageHandlers.performAction.postMessage({
              action: "navigateToBack",
            });
        }
    }

    editNews(){
        this.submitButtonTarget.setAttribute("disabled", "disabled")
        if (window?.Android && typeof window.Android.onBack == "function") {
            Android.onBack();
            return;
        } else if (window.webkit && window.webkit.messageHandlers) {
            webkit.messageHandlers.performAction.postMessage({
              action: "navigateToBack",
            });
            webkit.messageHandlers.performAction.postMessage({
              action: "navigateToBack",
            });
        }
    }

    openModal(){
        this.container.classList.remove("hidden");
    }

    closeModal(){
        this.container.classList.add("hidden");
    }
}